import { defineMessages } from 'react-intl'

export const translations = defineMessages({
  title: {
    defaultMessage: 'My Subscriptions',
    id: 'global.account.link.my_subscriptions'
  },
  subTitle: {
    defaultMessage: '{amount} subscriptions',
    id: 'msp.account.subscriptions.subtitle'
  },
  placeholderTitle: {
    id: 'msp.account.subscriptions.placeholder.title',
    defaultMessage: 'Don´t have an Avoury subscriptions yet?'
  },
  placeholderTextIntro: {
    id: 'msp.account.subscriptions.placeholder.text-intro',
    defaultMessage:
      'Set up your personal Avoury subscription from your order now and have your favourite tea conveniently delivered at an interval of your choice. The minimum order amount are 6 boxes of tea.'
  },
  placeholderTextBeforeSteps: {
    id: 'msp.account.subscriptions.placeholder.text-before-steps',
    defaultMessage: 'To do so:'
  },
  placeholderTextStep1: {
    id: 'msp.account.subscriptions.placeholder.text-step-1',
    defaultMessage:
      '1. Select your order in your customer account under “My orders”. Then place a new order for the products you want to receive by subscription or make use of an order that you have received before.'
  },
  placeholderTextStep2: {
    id: 'msp.account.subscriptions.placeholder.text-step-2',
    defaultMessage: '2. Convert your selected order into a subscription.'
  },
  placeholderTextStep3: {
    id: 'msp.account.subscriptions.placeholder.text-step-3',
    defaultMessage:
      '3. Fill in all the fields, such as the requested start date, delivery interval, subscription delivery address, payment method etc. You can also remove products or add products to the subscription here.'
  },
  placeholderTextStep4: {
    id: 'msp.account.subscriptions.placeholder.text-step-4',
    defaultMessage: '4. Save your subscription – and that’s it!'
  },
  placeholderTextAfterSteps: {
    id: 'msp.account.subscriptions.placeholder.text-after-steps',
    defaultMessage:
      'All the subscriptions you have set up are stored in your customer account under “My subscriptions” where you can also make changes, such as pausing a subscription when you go on vacation or deleting a subscription when you no longer want it. You can make changes up until 1 day before the next subscription is dispatched. All other deliveries can be changed or removed at any time.'
  },
  buttonText: {
    id: 'msp.account.subscriptions.placeholder.button',
    defaultMessage: 'Check your orders'
  },
  orderStatusActive: {
    id: 'msp.account.subscriptions.status.active',
    defaultMessage: 'active'
  },
  orderStatusInactive: {
    id: 'msp.account.subscriptions.status.inactive',
    defaultMessage: 'inactive'
  },
  orderStartDateLabel: {
    id: 'msp.account.subscriptions.label.start-date',
    defaultMessage: 'Start Date: '
  },
  orderStartDate: {
    id: 'msp.account.subscriptions.start-date',
    defaultMessage: 'from {startDate}'
  },
  orderDeliveryIntervalLabel: {
    id: 'msp.account.subscriptions.label.delivery-interval',
    defaultMessage: 'Delivery Interval: '
  },
  orderDeliveryInterval: {
    id: 'msp.account.subscriptions.delivery-interval',
    defaultMessage: 'Every {weeks} weeks'
  },
  orderNextShippingDateLabel: {
    id: 'msp.account.subscriptions.label.next-shipping-date',
    defaultMessage: 'Next shipment: '
  },
  orderTotalPrice: {
    id: 'msp.account.subscriptions.label.total-price',
    defaultMessage: 'Total price: '
  },
  orderViewDetail: {
    id: 'msp.account.subscriptions.link.view-detail',
    defaultMessage: 'View subscription'
  },
  detailsTitle: {
    id: 'msp.account.subscriptions.details.title',
    defaultMessage: 'Subscription Details: #{orderNo}'
  },
  detailsBackLink: {
    id: 'msp.account.subscriptions.details.backlink',
    defaultMessage: 'Go back to My Subscriptions'
  },
  detailShippingAddressLabel: {
    id: 'msp.account.subscriptions.details.shipping-address-label',
    defaultMessage: 'Shipping address'
  },
  detailBillingAddressLabel: {
    id: 'msp.account.subscriptions.details.billing-address-label',
    defaultMessage: 'Billing address'
  },
  detailPaymentLabel: {
    id: 'msp.account.subscriptions.details.payment-label',
    defaultMessage: 'Payment method'
  },
  detailDeliveryIntervalLabel: {
    id: 'msp.account.subscriptions.details.delivery-interval-label',
    defaultMessage: 'Delivery interval'
  },
  detailActionSkipNextDelivery: {
    id: 'msp.account.subscriptions.details.actions.skip-next-delivery',
    defaultMessage: 'Skip Next Delivery'
  },
  detailActionSuspend: {
    id: 'msp.account.subscriptions.details.actions.suspend',
    defaultMessage: 'Suspend'
  },
  detailActionActivate: {
    id: 'msp.account.subscriptions.details.actions.activate',
    defaultMessage: 'Activate'
  },
  detailActionChange: {
    id: 'msp.account.subscriptions.details.actions.change',
    defaultMessage: 'Edit'
  },
  detailActionDelete: {
    id: 'msp.account.subscriptions.details.actions.delete',
    defaultMessage: 'Delete'
  },
  detailOverviewDeliveries: {
    id: 'msp.account.subscriptions.details.overview-deliveries',
    defaultMessage: 'Overview of deliveries'
  },
  detailDeliveriesLabelDate: {
    id: 'msp.account.subscriptions.details.deliveries.date-label',
    defaultMessage: 'Date'
  },
  detailDeliveriesLabelStatus: {
    id: 'msp.account.subscriptions.details.deliveries.status-label',
    defaultMessage: 'Status'
  },
  detailDeliveriesLabelItem: {
    id: 'msp.account.subscriptions.details.deliveries.item-label',
    defaultMessage: 'Item'
  },
  detailDeliveriesSuspend: {
    id: 'msp.account.subscriptions.details.deliveries.suspend',
    defaultMessage: 'Suspend Delivery'
  },
  detailDeliveriesActivate: {
    id: 'msp.account.subscriptions.details.deliveries.activate',
    defaultMessage: 'Activate Delivery'
  },
  detailBottomText: {
    id: 'msp.account.subscription.details.botton-text',
    defaultMessage:
      'Promotional campaigns running during the course of your subscription and for products in your subscription are automatically taken into account.'
  },
  deleteConfirmationText: {
    id: 'msp.account.subscription.details.detele-confirmation',
    defaultMessage:
      'Are you sure you want to delete this subscription? This action cannot be undone.'
  },
  suspendConfirmationText: {
    id: 'msp.account.subscription.details.detele-confirmation',
    defaultMessage:
      'Are you sure you want to suspend this subscription? This action can be undone.'
  },
  activateConfirmationText: {
    id: 'msp.account.subscription.details.detele-confirmation',
    defaultMessage:
      'Are you sure you want to activate this subscription? This action can be undone.'
  },
  skipConfirmationText: {
    id: 'msp.account.subscription.details.detele-confirmation',
    defaultMessage:
      'Are you sure you want to skip next delivery of this subscription? This action can be undone.'
  },
  confirmBoxTitle: {
    id: 'msp.account.subscription.details.confirm-box-title',
    defaultMessage: 'Please confirm your action'
  },
  confirmBoxSubmit: {
    id: 'msp.account.subscription.details.confirm-box-submit',
    defaultMessage: 'Yes'
  },
  confirmBoxCancel: {
    id: 'msp.account.subscription.details.confirm-box-cancel',
    defaultMessage: 'Cancel'
  }
})
